module.exports = __webpack_public_path__ + "img/camera.8349ee8.png";